<lex-action-panel>
    <div action-title>Hits</div>
    <div action-body>
        <div style="height: 375px;">
            <div class='hits-content' style="height: 100%;">
                <div style="padding: 0 5px 10px 5px;">
                  <div class="content-top" style="position: sticky; top:0; height:10px; width: 100%; z-index: 1;"></div>
                  <div class="grey-header" *ngIf="normalizedHits$ | async as normalizedHits">
                    <div class="grey-header-left">Normalized PDF
                      ({{normalizedHits.length}} {{normalizedHits.length === 1 ? 'hit' : 'hits'}})
                    </div>
                  </div>
              
                  <div *ngFor="let hit of normalizedHits$ | async " class="hits-repeater normalized-hits">
                    <div class="normalized-hits-link-wrapper" style="margin: 10px 0 10px 4px;">
                      <a [routerLink]="[]" queryParamsHandling="preserve" (click)="navigateToPage(hit.pageNumber)">
                        <i class="fa-duotone fa-bullseye-pointer icon"></i>
                        {{hit.title}}
                    </a>
                    </div>
                    <div [innerHTML]="hit.hitText | safeHtml" class="hit-text" style="margin: 16px 2px 10px 4px;"></div>
                  </div>
              
                  <div class="grey-header" *ngIf="metadataHits$ | async as metadataHits">
                    <div class="grey-header-left">Metadata ({{metadataHits.length}} {{metadataHits.length === 1 ? 'hit' : 'hits'}})
                    </div>
                  </div>
              
                  <div *ngFor="let hit of metadataHits$ | async" class="hits-repeater">
                    <div [innerHTML]="hit.hitText | safeHtml" class="hit-text" style="margin: 10px 2px 10px 4px;"></div>
                  </div>
              
                  <div class="grey-header" *ngIf="insightHits$ | async as insightHits">
                    <div class="grey-header-left">Insights ({{insightHits.length}} {{insightHits.length === 1 ? 'hit' : 'hits'}})
                    </div>
                  </div>
              
                  <div *ngFor="let hit of insightHits$ | async" class="hits-repeater">
                    <div [innerHTML]="hit.hitText | safeHtml" class="hit-text" style="margin: 10px 2px 10px 4px;"></div>
                  </div>
              
                  <div class="grey-header" *ngIf="nativeHits$ | async as nativeHits">
                    <div class="grey-header-left">Native ({{nativeHits.length}} {{nativeHits.length === 1 ? 'hit' : 'hits'}})</div>
                  </div>
              
                  <div *ngFor="let hit of nativeHits$ | async" class="hits-repeater">
                    <div [innerHTML]="hit.hitText | safeHtml" class="hit-text" style="margin: 10px 2px 10px 4px;"></div>
                  </div>
              
                  <div class="grey-header" *ngIf="translatedHits$ | async as translatedHits">
                    <div class="grey-header-left">Translated
                      ({{translatedHits.length}} {{translatedHits.length === 1 ? 'hit' : 'hits'}})
                    </div>
                  </div>
              
                  <div *ngFor="let hit of translatedHits$ | async" class="hits-repeater">
                    <div [innerHTML]="hit.hitText | safeHtml" class="hit-text" style="margin: 10px 2px 10px 4px;"></div>
                  </div>
                </div>
              </div>
        </div>
    </div>
</lex-action-panel>
